'use client';

import type { FC } from 'react';
import { Skeleton } from './ui';
import { cn } from '../utils/cn';

interface WinnerListSkeletonProps {
  count?: number;
  withPrize?: boolean;
  thirdLineHasIcon?: boolean;
}

export const WinnerListSkeleton: FC<WinnerListSkeletonProps> = ({ count = 6, withPrize = true, thirdLineHasIcon = true }) => (
  <div className="flex flex-col gap-2 p-4">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="flex w-full items-center gap-3 rounded-2xl bg-fill-tertiary px-3.5 py-3">
        <Skeleton className="size-12 shrink-0 rounded-full" />
        <div className="min-w-0 flex-1 leading-tight">

          <Skeleton className="h-6 w-[45%]" />
          <Skeleton className="mt-0.5 h-5 w-[70%]" />
          <Skeleton className={cn('mt-0.5 w-[35%]', thirdLineHasIcon ? 'h-[18px]' : 'h-4')} />
        </div>
        {withPrize && <Skeleton className="h-16 w-16 shrink-0 rounded-xl" />}
      </div>
    ))}
  </div>
);
